import { Component, OnInit } from '@angular/core';
import { PostModel } from '../news-feed/post-feed/post.model';
import { INewsItem } from './news-item';
import { HttpClient } from '@angular/common/http';
import { faDownload, faPalette, faQuestion, faAt, faExclamationCircle, faStar } from '@fortawesome/free-solid-svg-icons';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  fileUrl: string = '../assets/api/news.json';
  newsItems: INewsItem[];
  errorMessage: string;
  public newsFeedPosts: PostModel[] = [];  

  /* Font Awesome Icons */
  faDownload = faDownload;  
  faPalette = faPalette;
  faQuestion = faQuestion;
  faNews = faStar;
  faAt = faAt;

  constructor(private _http: HttpClient) { }

  public getNewsItems(): Observable<INewsItem[]> {
    return this._http.get<INewsItem[]>(this.fileUrl)
    .pipe(catchError(this.handleError));
  }

  private handleError(err) {
    console.log(err.message);
    return Observable.throw(err.message);
  }

  ngOnInit(): void{
    this.getNewsItems().subscribe(
      items => {
        this.newsItems = items.sort((a, b) => a.id > b.id ? -1 : 1);
      },
      error => this.errorMessage = <any>error
    );
  }

}
